export const statusList = [
  { name: "UnAssigned", value: 1 },
  { name: "Pending", value: 2 },
  { name: "Resolved", value: 3 },
  { name: "Merged", value: 4 },
  { name: "Cancelled", value: 5 },
  { name: "WIP", value: 6 },
];

export const priorityList = [
  { name: "Low", value: 1 },
  { name: "Medium", value: 2 },
  { name: "High", value: 3 },
];

export const roles = [
  { name: "Admin", value: 1 },
  { name: "Agent", value: 2 },
  { name: "Supervisor", value: 3 },
  { name: "Technician", value: 4 },
  { name: "Regional Manager", value: 5 },
  { name: "Business Head", value: 6 },
];

export const ownerList = [
  { name: "LEAP", value: 1 },
  { name: "TARON", value: 2 },
  { name: "SKAN", value: 3 },
];

export const vehicleTypes = [
  { name: "Articulated Forklift", value: 1 },
  { name: "Forklift", value: 2 },
  { name: "Reach Truck", value: 3 },
  { name: "BOPT", value: 4 },
  { name: "Stacker", value: 5 },
  { name: "Tow Truck", value: 6 },
];

export const Categories = [
  { name: "Material", value: 1 },
  { name: "Maintenance", value: 2 },
  { name: "Machine", value: 3 },
  { name: "ManPower", value: 4 },
];

export const VehicleStatus = [
  { name: "Hired Breakdown", value: 1 },
  { name: "Stand by Available", value: 2 },
  { name: "Dehired", value: 3 },
  { name: "Hired", value: 4 },
];

export const lineOfBusiness = {
  "02": "FMCG",
  "01": "Auto",
};

export const colHeadersTROUT = {
  "BP_Code": "BP Code",
  "BP_Name": "BP Name",
  "LoB": "LOB",
  "Transfer_Type": "Transfer Type",
  "To_Customer": "To Customer",
  "Customer_Address": "Customer Address",
  "SKU": "SKU",
  "Posting_date": "Posting Date",
  "Document_Date": "Doc Date",
  "Transporter_Name": "Transporter Name",
  "Vehicle_Number": "Vehicle No",
  "LR_No": "LR No",
  "Invoice_No": "Invoice No",
  "Remark": "Remarks",
}
